
export enum PlannerTabTypes {
    meals,
    chores,
    activity,
    summary,
    none
}